import { updateUserWithFidelityCard } from '../actions/userActions';
import { extractErrorMessage, getCustomErrorMessage } from './errorHandlerFidelity';

const CIVILITY_MAPPING = {
  M: 1,
  Mme: 2,
  Mlle: 3
};

const CONTACT_TYPES = {
  EMAIL: 2,
  MOBILE: 3
};

const CONTACT_STATUS = {
  ACTIVE: 1,
  AVALIDER: 2
};

const DEFAULT_COUNTRY_CODE = "FR";
const DEFAULT_LANGUAGE = "fr";

const formatDateForBackend = (dateObj) => {
  const { day, month, year } = dateObj;
  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
};

const parseFullName = (fullName) => {
  const [prenom, ...nomArray] = fullName.trim().split(' ');
  const nom = nomArray.join(' ');
  return { prenom, nom };
};

const createContactInfo = (email, justPhoneNumber, indicatif, emailOptin = false, smsOptin = false) => ({
  mail: {
    email,
    numTypeContact: CONTACT_TYPES.EMAIL,
    statutContact: CONTACT_STATUS.AVALIDER,
    optin: emailOptin,
    optout: emailOptin
  },
  telephones: [
    {
      numero: justPhoneNumber,
      indicatif: indicatif,
      numTypeContact: CONTACT_TYPES.MOBILE,
      statutContact: CONTACT_STATUS.AVALIDER,
      optin: smsOptin,
      optout: smsOptin
    }
  ]
});

const buildFicheClient = (formData) => {
  const { fullName, civility, birthDate, email, justPhoneNumber, indicatif, emailOptin, smsOptin } = formData;
  const { prenom, nom } = parseFullName(fullName);
  const contactInfo = createContactInfo(email, justPhoneNumber, indicatif, emailOptin, smsOptin);

  return {
    nom,
    prenom,
    numCivilite: CIVILITY_MAPPING[civility] || CIVILITY_MAPPING.Mlle,
    dateNaissance: formatDateForBackend(birthDate),
    code_pays: DEFAULT_COUNTRY_CODE,
    langueClient: DEFAULT_LANGUAGE,
    ...contactInfo
  };
};

const handleApiError = (error) => {
  const status = error.response?.status;
  const errorData = error.response?.data;

  if (status >= 500) {
    return {
      success: false,
      message: extractErrorMessage(error),
      errorCode: status,
      isServerError: true,
      shouldRetry: true,
      data: errorData
    };
  }

  if (!errorData) {
    return {
      success: false,
      message: "Erreur de connexion. Veuillez vérifier votre connexion internet et réessayer.",
      data: null,
      shouldRetry: true
    };
  }

  let errorMessage = extractErrorMessage(error);
  let errorCode = null;

  // Extract error code from structured backend errors
  if (errorData.erreurs?.length > 0) {
    const backendError = errorData.erreurs[0];
    errorCode = backendError.code;

    const customMessage = getCustomErrorMessage(errorCode);
    if (customMessage) {
      errorMessage = customMessage;
    }
  }

  return {
    success: false,
    message: errorMessage,
    errorCode,
    data: errorData,
    shouldRetry: status >= 500 || status === 0 // Retry pour erreurs serveur ou pas de réponse
  };
};

export const createFidelityCard = async (formData, axiosInstance, userId, storeId, dispatch) => {
  try {
    const successMessage = "Carte de fidélité créée avec succès";
    const ficheClient = buildFicheClient(formData);
    console.info('storeId', storeId);

    const response = await axiosInstance.post(
      '/fidelity-card/createUserAndCard',
      { ficheClient, userId, storeId }
    );
    
    const userFidCard = response?.data?.data?.userFidCard;
    
    if (userFidCard && userFidCard.length > 0 && dispatch) {
      const firstFidCard = userFidCard[0];
      await dispatch(updateUserWithFidelityCard(firstFidCard));
      console.info('User updated with fidelity card from backend:', firstFidCard);
    }

    return {
      success: true,
      message: successMessage,
      data: response.data
    };
  } catch (error) {
    console.error('Error creating fidelity card', error);
    return handleApiError(error);
  }
};

export const getFidelityCards = async (axiosInstance) => {
  try {
    const response = await axiosInstance.get('/api/fidelity');
    return response.data;
  } catch (error) {
    console.error('Error getting fidelity cards', error);
    throw error;
  }
};